import React, { PureComponent } from 'react';

import DateRange from './date-range';

export default class DateRangeElement extends PureComponent {
    static defaultProps = {
        value: {}
    }

    state = {
        visible: false
    }

    handleChange = range => {
        const start = range.start && new Date(range.start).getTime();
        const end = range.end && new Date(range.end).getTime();

        this.props.onChange && this.props.onChange({ start, end });
    }

    handleClick = () => {
        if (this.state.visible) {
            this.hide();

            return;
        }

        this.show();
    }

    show() {
        if (!this.dateCtrl) {
            return;
        }

        this.dateCtrl.show();
    }

    hide() {
        if (!this.dateCtrl) {
            return;
        }

        this.dateCtrl.hide();
    }

    handleShow = () => {
        this.setState({
            visible: true
        });
    }

    handleHide = () => {
        this.setState({
            visible: false
        });
    }

    setDateCtrl = ctrl => this.dateCtrl = ctrl;

    componentDidMount() {
        this.props.provideController && this.props.provideController({
            show: () => {
                this.show();
            }
        });
    }

    componentWillUnmount() {
        this.props.provideController && this.props.provideController(null);
    }

    render() {
        const childrenWithProps = React.Children.map(this.props.children, child => {
            return React.cloneElement(child, {
                onClick: this.handleClick
            });
        });

        return (
            <React.Fragment>
                { childrenWithProps }

                <DateRange
                    title={this.props.title}
                    start={this.props.value && this.props.value.start}
                    end={this.props.value && this.props.value.end}
                    xAlign={this.props.xAlign}
                    onChange={this.handleChange}
                    onRemove={this.props.onRemove}
                    onShow={this.handleShow}
                    onHide={this.handleHide}
                    provideController={this.setDateCtrl}
                />
            </React.Fragment>
        )
    }
}
